module.exports = __webpack_public_path__ + "assets/img/Culture_005.c9de2571-ps.jpg";